import { api } from "./api";
import { decimalUnits } from "./receivedInvoices";

export interface SiteCost {
  gradiliste_id: string;
  gradiliste: string;
  vrsta: string;
  iznos: string;
  currency: "EUR";
}
export const costCategories = ["Gradilišni materijal", "Usluge", "OZO i sitni"] as const;
const category: Record<string, string> = {
  gradilisni: costCategories[0],
  usluge: costCategories[1],
  prijevoz: costCategories[1],
  ozo: costCategories[2],
  sitno: costCategories[2],
};
export function centsString(value: bigint) {
  return `${value / 100n}.${(value % 100n).toString().padStart(2, "0")}`;
}
export function groupSiteCosts(rows: SiteCost[]) {
  const sites = new Map<string, { id: string; name: string; total: bigint; categories: Record<string, bigint> }>();
  for (const row of rows) {
    const amount = decimalUnits(row.iznos);
    if (amount === null || row.currency !== "EUR") throw new Error("Troškovi moraju imati valjane neto iznose u EUR.");
    const site = sites.get(row.gradiliste_id) ?? {
      id: row.gradiliste_id,
      name: row.gradiliste || "Gradilište bez naziva",
      total: 0n,
      categories: Object.fromEntries(costCategories.map((key) => [key, 0n])),
    };
    const key = category[row.vrsta] || row.vrsta;
    site.categories[key] = (site.categories[key] ?? 0n) + amount;
    site.total += amount;
    sites.set(site.id, site);
  }
  return [...sites.values()].sort((a, b) => a.name.localeCompare(b.name, "hr"));
}
export const invoiceCosts = {
  list: async (month: string, signal?: AbortSignal) =>
    (await api.get<SiteCost[]>("/nabava/troskovi-gradilista", { params: { month }, signal })).data,
};
